@use '@/styles/tokens' as *;

// Figma node 219:329628 — a full-content-width grey band above the metrics row.

.banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-4) var(--space-5);
  border-radius: $radius-xl;
  // `--surface-muted` is #EFEFEA, the exact fill sampled off Figma 219:329628. `neutral-100`
  // (#F4F4F4) was 12 away and read as a cooler, flatter grey than the design's warm band.
  background: var(--surface-muted);
}

.text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.title {
  margin: 0;
  font-size: $font-size-16;
  font-weight: $font-weight-medium;
  line-height: 1.3;
  color: var(--text-primary);
}

.body {
  margin: 0;
  font-size: $font-size-14;
  line-height: 1.4;
  color: var(--text-tertiary);
}

.cancel {
  flex: none;
  // Borderless: the design draws Cancel as plain red text on the band, with no button chrome.
  // `<Button variant="subtle">` gave it a white pill, which read as a second surface floating on
  // the banner. `<TextButton>` is the repo's borderless control, and its `danger` tone is
  // overridden here because that tone is `error-500` (#FF725C) while the design's red is
  // `error-900` (#E7040F) exactly.
  color: $color-error-900 !important;
  font-weight: $font-weight-medium;
}
